import React from 'react';
import * as yup from 'yup';
import {
  Box,
  BoxProps,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { SparkForm } from 'sharedComponents/SparkForm';
import { SearchIcon } from 'components/SVG';
import CloseIcon from '@mui/icons-material/Close';
import { useDebounce } from 'hooks/common';

type SparkDataSearchBarProps = {
  placeholder?: string;
  sx?: BoxProps['sx'];
  setQuery: (filteredData: string) => void;
  query?: string;
};

function SparkDataSearchBar({
  placeholder,
  sx,
  setQuery,
  query,
}: SparkDataSearchBarProps) {
  const [localQuery, setLocalQuery] = React.useState('');
  const debounce = useDebounce();
  const debouncedSearch = debounce((queryString: string) => {
    setQuery(queryString);
  }, 300);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const queryString = event.target.value;
    setLocalQuery(queryString);
    debouncedSearch(queryString);
  };

  const handleClearSearch = () => {
    setLocalQuery('');
    setQuery('');
  };

  return (
    <Box sx={{ marginRight: 2, mb: 2, ...sx }}>
      <SparkForm
        initialValues={{}}
        validationSchema={yup.object()}
        onSave={() => {}}
      >
        <TextField
          placeholder={placeholder}
          fullWidth
          autoComplete='off'
          onChange={handleChange}
          value={query || localQuery}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: localQuery.length > 0 && (
              <InputAdornment position='end'>
                <IconButton
                  onClick={handleClearSearch}
                  aria-label='Clear search'
                >
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #EEEEEE',
            borderRadius: '12px',
          }}
        />
      </SparkForm>
    </Box>
  );
}

export default SparkDataSearchBar;
